export const cta = {
	bcc: 'joey.ruse@slalom.com',
	body: encodeURIComponent(
		'Thanks for reaching out! \n\n' +
			'Let us know how we can help with scheduling live brainstorming sessions, creating prototypes of your ideas, or using/improving the ideation tools platform.'
	),
	subject: 'Slalom Ideation Tools Outreach',
}
